import appConfig from '../app-config';
export const guestInfoClients = ['onekingwest_amenities'];
export const isGuestOrderInfoClient = guestInfoClients.includes(
  appConfig.appSource
);
export const favoriteClients = ['picassos', 'hat_six', 'williebs'];
